import CreateGroupContainer from "./CreateGroupContainer";

export default CreateGroupContainer;
